/** The server refused a draft-lane write because what it was based on moved
 * (SA-404). `published_since` is the Configure lane's code (SA-1410); this
 * lane should never receive it, but if it does it reads as the version
 * moving. */
import type { DraftConflict } from '@/hooks/useWorkflowDraft'

export const DRAFT_CONFLICT_TEXT: Record<DraftConflict, string> = {
  stale: 'Someone saved a newer draft — reload to continue.',
  base_moved: 'A newer version was published — reload to continue.',
  published_since: 'A newer version was published — reload to continue.',
}
